module.exports = __webpack_public_path__ + "static/media/dma-logo-white.12b5bf2c.svg";